// extracted by mini-css-extract-plugin
export default {"root":"vi2xOm","debugBorder":"KTObcr"};